export default {"src":"/_next/static/media/CLF.8a30c59a.svg","height":18,"width":18};